import React from 'react';
import { Code, Mail, Phone, MapPin, Twitter, Linkedin, Github, Facebook } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const navigate = useNavigate();

    const footerLinks = {
        services: [
            { name: 'Web Development', href: '#services' },
            { name: 'Mobile Apps', href: '#services' },
            { name: 'Data Management', href: '#services' },
            { name: 'Security Solutions', href: '#services' }
        ],
        products: [
            { name: 'FinanceFlow Pro', href: '#products' },
            { name: 'TaxMaster Suite', href: '#products' },
            { name: 'ReportGenius', href: '#products' },
            { name: 'SecureVault', href: '#products' }
        ],
        company: [
            { name: 'About Us', href: '#about' },
            { name: 'Our Team', href: '#about' },
            { name: 'Careers', href: '#' },
            { name: 'Contact', href: '#contact' }
        ],
        resources: [
            { name: 'Blog', href: '#' },
            { name: 'Documentation', href: '#' },
            { name: 'Support', href: '#' },
        ]
    };

    const socialLinks = [
        { icon: Twitter, href: '#', name: 'Twitter' },
        { icon: Linkedin, href: '#', name: 'LinkedIn' },
        { icon: Github, href: '#', name: 'GitHub' },
        { icon: Facebook, href: '#', name: 'Facebook' }
    ];

    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-8">
                    <div className="lg:col-span-2">
                        <div className="flex items-center space-x-2 mb-4">
                            <div className="bg-white p-2 rounded-lg">
                                <img src='./logo.png' className='w-6 h-6' />
                            </div>
                            <span className="text-xl font-bold">Newline Infotech Pvt Ltd.</span>
                        </div>
                        <p className="text-gray-400 mb-6 leading-relaxed">
                            Transforming finance offices through innovative technology solutions.
                            We build apps and websites that streamline operations and drive growth.
                        </p>
                        <div className="space-y-2">
                            <div className="flex items-center space-x-3 text-gray-400">
                                <Mail className="w-4 h-4" />
                                <span className="text-sm">support@nipl.in</span>
                            </div>
                            <div className="flex items-center space-x-3 text-gray-400">
                                <Phone className="w-4 h-4" />
                                <span className="text-sm">+91 98290 15824</span>
                            </div>
                            <div className="flex items-start space-x-3 text-gray-400">
                                <MapPin className="w-4 h-4" />
                                <span className="text-sm">1st Floor Above Upkar Store <br /> Saheli Marg, Panchwati, Udaipur, Rajasthan 313001</span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Services</h3>
                        <ul className="space-y-2">
                            {footerLinks.services.map((link, index) => (
                                <li key={index}>
                                    <button
                                        onClick={() => scrollToSection('services')}
                                        className="text-gray-400 hover:text-white transition-colors text-sm"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Products</h3>
                        <ul className="space-y-2">
                            {footerLinks.products.map((link, index) => (
                                <li key={index}>
                                    <button
                                        onClick={() => scrollToSection('products')}
                                        className="text-gray-400 hover:text-white transition-colors text-sm"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Company</h3>
                        <ul className="space-y-2">
                            {footerLinks.company.map((link, index) => (
                                <li key={index}>
                                    <button
                                        onClick={() => scrollToSection(link.href.replace('#', ''))}
                                        className="text-gray-400 hover:text-white transition-colors text-sm"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Resources</h3>
                        <ul className="space-y-2">
                            <li>
                                <p onClick={() => navigate('privacy-policy')} className="cursor-pointer text-gray-400 hover:text-white transition-colors text-sm">
                                    Privacy Policy
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-12 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="text-gray-400 text-sm mb-4 md:mb-0">
                            © 2025 Newline Infotech. All rights reserved.
                        </div>
                        <div className="flex space-x-4">
                            {socialLinks.map((social, index) => (
                                <a
                                    key={index}
                                    href={social.href}
                                    className="text-gray-400 hover:text-white transition-colors"
                                    aria-label={social.name}
                                >
                                    <social.icon className="w-5 h-5" />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;